
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SierpinskiTriangleEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
         const size = (400 + layerIndex * 150) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, size);
        const scale = config.parallaxScale || 1.0;
        const iterations = Math.floor(4 * (config.parallaxComplexity || 1.0));

        ctx.strokeStyle = pc.color;

        const drawSierpinski = (x: number, y: number, s: number, level: number) => {
            if (level === 0) {
                ctx.beginPath();
                ctx.moveTo(x, y - s / 2);
                ctx.lineTo(x - s / 2, y + s / 2);
                ctx.lineTo(x + s / 2, y + s / 2);
                ctx.closePath();
                ctx.stroke();
                return;
            }

            const ns = s / 2;
            drawSierpinski(x, y - ns / 2, ns, level - 1);
            drawSierpinski(x - ns / 2, y + ns / 2, ns, level - 1);
            drawSierpinski(x + ns / 2, y + ns / 2, ns, level - 1);
        };

        const draw = () => {
            for (let x = x1; x <= x2; x += size) {
                for (let y = y1; y <= y2; y += size) {
                    drawSierpinski(x, y, size * 0.9 * scale, iterations);
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
